import React from 'react';

export const Developers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 26 18" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.9288 4.78159L2.2551 9.45529L6.9288 14.1291"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0712 4.78159L23.7449 9.45529L19.0712 14.1291"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.44211 17.1733L16.5478 0.826691"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
